import React from "react";
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import CandidateHeader from '../Candidate/Candidate Navbar/Header';
import ExamNavbar from "./ExamNavbar";


export default function GoToExam() {
    const navigate = useNavigate();
    const location = useLocation();
    const exam = location.state.exam;

    const handleClick = (() => {
        navigate('/start-exam', {
            state: {
                exam: exam,
                numQues: 60
            }
        });
    });

    return (
        <section>
            {/* ====================== Header and Navbar ====================== */}
      <CandidateHeader />
      <ExamNavbar />
      {/* ====================== body ====================== */}
      <div className="container">
        <div className="course-container d-flex justify-content-center align-items-center">

        <div className="card m-3 my-4 px-sm-3 " style={{maxWidth:"750px",width:"100%"}} >
            <div className="card-body ">
                 <h2 className="text-center text-capitalize">{exam['name']}</h2>
                <h4 className="card-title pb-2 text-center">Exam Info</h4>
                <p className="card-text text-sm-center ">This exam is conducted by <span style={{ color: "darkblue" }} className="fw-bold">ASPIRE IT ACADEMY.</span>
                    <br /> Attend all MCQ questions and enhance your IT skills.</p>
                <p className="card-text">Number Of Questions: <span style={{ color: "darkblue" }} className="fw-bold">60</span></p>
                <p className="card-text">Time duration: <span style={{ color: "darkblue" }} className="fw-bold">1 hr</span> </p>
                <p className="card-text">Percentage: <span style={{ color: "darkblue" }} className="fw-bold">Get 80 above</span> </p>
                <p className="card-text">Certificate provided by: <span style={{ color: "darkblue" }} className="fw-bold">ASPIRE IT ACADEMY</span></p>
                <h5 className="card-text text-center">All the best!</h5>
                <div className="mt-3 d-flex justify-content-end gap-3">
                     <button className="btn btn-link" type="button" onClick={() => navigate(-1)}>Back</button>
                    <button className="btn btn-success exam-btn" type="button" onClick={handleClick}>Start Exam</button>
                </div>
          
            </div>
        </div>
        </div>
      </div>
        </section>
    )
}